import React from 'react';
import { Dialog } from '@biq/apex-ui';
import { DialogContent, DialogContentText } from '@mui/material';
import {
    InvalidPermissionsDialogProps,
    styles,
} from './invalid-permissions-helper';

const InvalidPermissionsDialog = ({
    onClose,
    open = false,
}: InvalidPermissionsDialogProps): React.JSX.Element => {
    const handleClose = (): void => {
        onClose();
    };

    return (
        <Dialog
            closable
            open={open}
            title={`Invalid Permissions`}
            onClose={handleClose}
            sx={styles.dialog}
        >
            <DialogContent>
                <DialogContentText style={styles.dialogContentText}>
                    You do not have permissions to make changes. Please contact
                    your administrator.
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default InvalidPermissionsDialog;
